module.exports = __webpack_public_path__ + "static/media/events-add-radiation-risk.069807b0.svg";